import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
  
let routes = [
  {
    path: '/search/pro-food',
    name: 'pro-food',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {
      product_type: 'Food',
      title: 'Amazon Products | Search'
    }
  },
  {
    path: '/search/pro-baby',
    name: 'pro-baby',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {product_type: 'Baby'}
  },
  {
    path: '/search/pro-healthpersonalbeauty',
    name: 'pro-healthpersonalbeauty',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {product_type: 'HealthPersonalBeauty'}
  },
  {
    path: '/search/pro-officeart',
    name: 'pro-officeart',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {product_type: 'OfficeArt'}
  },
  {
    path: '/search/pro-patiosports',
    name: 'pro-patiosports',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {product_type: 'PatioSport'}
  },
  {
    path: '/search/pro-pets',
    name: 'pro-pets',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {product_type: 'Pet'}
  },
  {
    path: '/search/pro-toyselectronics',
    name: 'pro-toyselectronics',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {product_type: 'ToyElectronics'}
  },
  {
    path: '/search/hobby-baby',
    name: 'hobby-baby',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {product_type: 'Baby'}
  },
  {
    path: '/search/hobby-patiosports',
    name: 'hobby-patiosports',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {product_type: 'PatioSport'}
  },
  {
    path: '/search/hobby-pets',
    name: 'hobby-pets',
    component: () => import(/* webpackChunkName: "Pet" */ './views/Pet.vue'),
    meta: {product_type: 'Pet'}
  },
  {
    path: '/search/test',
    name: 'test',
    component: () => import(/* webpackChunkName: "Test" */ './views/Test.vue'),
  },
  {
    path: '/import-csv',
    name: 'import-csv',
    component: () => import(/* webpackChunkName: "ImportCSV" */ './views/ImportCSV.vue'),
  },

  {
    path: '/scrape-by-category',
    name: 'scrape-by-category',
    component: () => import(/* webpackChunkName: "ScrapeByCategory" */ './views/ScrapeByCategory.vue'),
  },
];

const router = new Router({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
});

router.beforeEach((to, from, next) => {
  document.title = "Amazon Product - Search"
  return next()
});

export default router;
